import moment from 'moment';
import 'moment/locale/id';
import _ from "lodash";

export const getFileNameFromUrl = (url) => {
    const filename = url.split('/').pop();
    return filename;
}

export const getFileExtensionFromUrl = (url) => {
    const filename = url.split('/').pop();

    const parts = filename.split('.');
    const extension = parts.length > 1 ? parts.pop() : '';

    return extension;
} 

export const checkPath = (path) => {
    const pattern = /^\/[^\/]+(?:\/[^\/]+)*\/[^\/]+\.[a-zA-Z]+$/;
    const urlpath = "/"+path;
    return pattern.test(urlpath);
}

export const isUrl = (url) => {
    try {
        var parsedURL = new URL(url);
        if (parsedURL.protocol === 'https:' || parsedURL.protocol === "http:") return true;
    } catch(e) {
        return false;
    }
}

export const unixAutoNumber = (number, length = 2) => {
    var output = number + '';
    while (output.length < length) {
        output = '0' + output;
    }
    return output;
}


export const timestamp = (lang="en") => {
    const now = moment();
    if(lang === "id") now.locale("id");
    return now.format('dddd, D MMMM YYYY HH:mm:ss Z');
}

export const getDocuments = (data = []) => {
  const templates = _.get(data, 'templates', []);
  const values = [];

  _.forEach(templates, (template) => {
    _.forEach(_.get(template, 'contents', []), (content) => {
      _.forEach(_.get(content, 'fields', []), (field) => {
        if (field.type === 'document') {
          const val = _.get(field, 'items[0].value');
          if (val) values.push(val);
        }
      });
    });
  });

  return _.flatMap(values, (v) => {
    try {
      return JSON.parse(v);
    } catch {
      return [];
    }
  });
}


